module.exports = __webpack_public_path__ + "img/BETIRO.9823ed67.svg";